/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from 'react';
import FileIcons from 'file-icons-js';

import AuthService from '../../state/auth.service';
import FileApi from '../../api/file';

class FileCard extends React.Component {
    constructor(props, context) {
        super(props, context);

        // The removed flag is a little hokey, but lets us handle everything
        // in this component instead of having to reload the entire criterion
        this.state = {
            downloadLink: null,
            removed: false,
        };

        this.removeFile = this.removeFile.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
    }

    removeFile() {
        const file = this.props.file;
        const criterionId = file.criterion_id;
        const fileId = file.file_key;
        console.log(file);
        console.log(fileId);
        FileApi.deleteFile(criterionId, fileId).then(() => {
            this.setState({ downloadLink: null, removed: true });
        });
    }

    downloadFile() {
        // This bit of monkey business is because we have to generate a signed
        // link in AWS to send to the user. These links are good only for a
        // limited amount of time, so we generate them on demand. That said,
        // we still want these links to download a file when the user clicks
        // it. So, we generate the url and initiate a click event on a hidden
        // link so that the pop-up blockers don't block us.
        const file = this.props.file;
        const criterionId = file.criterion_id;
        const filename = file.file_key;
        const fileId = file.s3_id;
        FileApi.getDownloadURL(criterionId, filename, fileId).then(url => {
            this.setState({ downloadLink: url }, () => {
                this.hiddenLink.click();
            });
        });
    }

    render() {
        const file = this.props.file;
        if (!file || this.state.removed) {
            return null;
        }
        const user = AuthService.getUser();

        const icon = FileIcons.getClass(file.s3_id);
        let downloadLink = (
            <a onClick={this.downloadFile}>
                <i className={icon}></i>
                {file.s3_id}
            </a>
        );

        let deleteLink = null;
        if (
            user.role === 'Administrator' ||
            user.role === 'Restricted' ||
            user.role === 'Document Provider'
        ) {
            deleteLink = (
                <a
                    onClick={() => {
                        this.removeFile();
                    }}>
                    <i className="fa fa-trash"></i>
                </a>
            );
        }

        return (
            <div className="FileCard">
                <a
                    ref={hiddenLink => (this.hiddenLink = hiddenLink)}
                    download={file.s3_id}
                    href={this.state.downloadLink}
                    className="hidden">
                    {this.state.downloadLink}
                </a>
                <div className="FileCard__file">{downloadLink}</div>
                <div className="FileCard__controls">{deleteLink}</div>
            </div>
        );
    }
}

export default FileCard;
